import { MyPage } from '#src/components/mySorare/MyPage/index.tsx';
import { useSortByDate } from '#src/components/mySorare/common/useSortByDate.tsx';
import { useSportSelect } from '#src/components/mySorare/common/useSportSelect.tsx';

import { BoughtSingleSaleOffers } from './BoughtSingleSaleOffers/index.tsx';

export const MyPurchases = () => {
  const { sortType, sortSelectNode } = useSortByDate();
  const { sportInputValue, sportSelectNode } = useSportSelect();

  return (
    <MyPage
      toolbar={
        <>
          {sportSelectNode}
          {sortSelectNode}
        </>
      }
    >
      <BoughtSingleSaleOffers sortType={sortType} sport={sportInputValue} />
    </MyPage>
  );
};
